// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-form-container {
  min-height: 100vh;
  background: var(--grey-shade-three);
  padding: 2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
}
@media (max-width: 768px) {
  .client-form-container {
    padding: 1rem;
  }
}
.client-form-container .client-form-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: client-form-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .client-form-container .client-form-wrapper {
    padding: 1rem;
    width: 95%;
  }
}
.client-form-container .client-form-header {
  position: relative;
  text-align: center;
  margin-bottom: 0.5rem;
}
.client-form-container .client-form-header .client-form-title {
  font-size: 1.3rem;
  font-weight: 500;
  color: #374151;
  margin: 0;
}
@media (max-width: 768px) {
  .client-form-container .client-form-header .client-form-title {
    font-size: 1.25rem;
  }
}
.client-form-container .client-form-divider {
  border: none;
  border-top: 1px solid var(--grey-shade-two);
  margin: 1.5rem 0;
}
.client-form-container .client-form-content {
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
}
.client-form-container .form-section {
  background: transparent;
  border-radius: 0.375rem;
  margin-bottom: 1.5rem;
}
.client-form-container .form-section.end-client {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .client-form-container .form-section {
    padding: 1rem;
  }
}
.client-form-container .form-section h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--grey-shade-two);
}
.client-form-container .form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
.client-form-container .form-row:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .client-form-container .form-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.client-form-container .form-group {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.client-form-container .form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.client-form-container .form-group label .clientform-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.client-form-container .form-group input,
.client-form-container .form-group select,
.client-form-container .form-group textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.client-form-container .form-group input:focus,
.client-form-container .form-group select:focus,
.client-form-container .form-group textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.client-form-container .form-group input:hover:not(:focus),
.client-form-container .form-group select:hover:not(:focus),
.client-form-container .form-group textarea:hover:not(:focus) {
  border-color: #9ca3af;
}
.client-form-container .form-group input::placeholder,
.client-form-container .form-group select::placeholder,
.client-form-container .form-group textarea::placeholder {
  color: #9ca3af;
}
.client-form-container .form-group input:disabled,
.client-form-container .form-group select:disabled,
.client-form-container .form-group textarea:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.client-form-container .form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.client-form-container .form-group textarea {
  height: auto;
  min-height: 4rem;
  resize: vertical;
  line-height: 1.5;
}
.client-form-container .form-group .toggle-container {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-top: 0.5rem;
}
.client-form-container .form-group .toggle-container .toggle-switch {
  position: relative;
  width: 50px;
  height: 24px;
  cursor: pointer;
}
.client-form-container .form-group .toggle-container .toggle-switch input[type=checkbox] {
  opacity: 0;
  position: absolute;
  width: 0;
  height: 0;
}
.client-form-container .form-group .toggle-container .toggle-switch input[type=checkbox]:checked + .toggle-slider {
  background-color: #3b82f6;
}
.client-form-container .form-group .toggle-container .toggle-switch input[type=checkbox]:checked + .toggle-slider:before {
  transform: translateX(26px);
}
.client-form-container .form-group .toggle-container .toggle-switch input[type=checkbox]:focus + .toggle-slider {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.client-form-container .form-group .toggle-container .toggle-switch .toggle-slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--grey-main-bg);
  border-radius: 24px;
  transition: all 0.3s ease;
}
.client-form-container .form-group .toggle-container .toggle-switch .toggle-slider:before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: white;
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.client-form-container .form-group .toggle-container .toggle-switch:hover .toggle-slider {
  background-color: #9ca3af;
}
input:checked + .client-form-container .form-group .toggle-container .toggle-switch:hover .toggle-slider {
  background-color: #2563eb;
}
.client-form-container .form-group .toggle-container .toggle-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
}
.client-form-container .form-group .toggle-description {
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 0.375rem;
  font-style: italic;
  line-height: 1.4;
}
.client-form-container .case-selector-container {
  width: 100%;
}
.client-form-container .case-selector-multi {
  position: relative;
  width: 100%;
}
.client-form-container .case-selector-multi label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.client-form-container .case-selector-multi .dropdown-wrapper {
  position: relative;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  background: #ffffff;
  transition: all 0.2s ease;
}
.client-form-container .case-selector-multi .dropdown-wrapper:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.client-form-container .case-selector-multi .dropdown-wrapper:hover:not(:focus-within) {
  border-color: #9ca3af;
}
.client-form-container .case-selector-multi .search-input-container {
  position: relative;
  display: flex;
  align-items: center;
}
.client-form-container .case-selector-multi .search-input-container .search-input {
  width: 100%;
  border: none;
  outline: none;
  padding: 0.5rem;
  font-size: 0.875rem;
  background: transparent;
  height: 2.5rem;
  box-sizing: border-box;
  color: #374151;
}
.client-form-container .case-selector-multi .search-input-container .search-input::placeholder {
  color: #9ca3af;
}
.client-form-container .case-selector-multi .search-input-container .dropdown-arrow {
  position: absolute;
  right: 0.5rem;
  color: #6b7280;
  pointer-events: none;
  transition: transform 0.2s ease;
}
.dropdown-wrapper:focus-within .client-form-container .case-selector-multi .search-input-container .dropdown-arrow {
  transform: rotate(180deg);
}
.client-form-container .case-selector-multi .selected-cases-container {
  padding: 0.75rem;
  border-top: 1px solid var(--grey-main-bg);
  min-height: 2rem;
  background: #f9fafb;
}
.client-form-container .case-selector-multi .selected-cases-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.client-form-container .case-selector-multi .court-section .court-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}
.client-form-container .case-selector-multi .court-section .cases-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
}
.client-form-container .case-selector-multi .case-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 500;
  transition: all 0.2s ease;
}
.client-form-container .case-selector-multi .case-tag.high-court {
  background-color: #fef3c7;
  color: #92400e;
  border: 1px solid #f59e0b;
}
.client-form-container .case-selector-multi .case-tag.high-court:hover {
  background-color: #fde68a;
}
.client-form-container .case-selector-multi .case-tag.district-court {
  background-color: #dbeafe;
  color: #1e40af;
  border: 1px solid #3b82f6;
}
.client-form-container .case-selector-multi .case-tag.district-court:hover {
  background-color: #bfdbfe;
}
.client-form-container .case-selector-multi .case-tag.other-court {
  background-color: #f3e8ff;
  color: #7c3aed;
  border: 1px solid #8b5cf6;
}
.client-form-container .case-selector-multi .case-tag.other-court:hover {
  background-color: #e9d5ff;
}
.client-form-container .case-selector-multi .case-tag .remove-btn {
  background: none;
  border: none;
  color: currentColor;
  cursor: pointer;
  font-size: 1rem;
  padding: 0;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  opacity: 0.7;
  transition: all 0.2s ease;
}
.client-form-container .case-selector-multi .case-tag .remove-btn:hover {
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.6);
  transform: scale(1.1);
}
.client-form-container .case-selector-multi .no-selection {
  color: #9ca3af;
  font-style: italic;
  font-size: 0.875rem;
  text-align: center;
  padding: 1rem;
}
.client-form-container .case-selector-multi .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  margin-top: 0.25rem;
  overflow: hidden;
  animation: dropdown-fade-in 0.2s ease-out;
}
.client-form-container .case-selector-multi .dropdown-header {
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.client-form-container .case-selector-multi .dropdown-header .court-tabs {
  display: flex;
}
.client-form-container .case-selector-multi .dropdown-header .court-tabs .tab-btn {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
}
.client-form-container .case-selector-multi .dropdown-header .court-tabs .tab-btn:hover {
  background: #f3f4f6;
  color: #374151;
}
.client-form-container .case-selector-multi .dropdown-header .court-tabs .tab-btn.active {
  background: #ffffff;
  color: #3b82f6;
  font-weight: 600;
  border-bottom-color: #3b82f6;
}
.client-form-container .case-selector-multi .dropdown-content {
  max-height: 250px;
  overflow-y: auto;
}
.client-form-container .case-selector-multi .dropdown-content .cases-list {
  padding: 0.25rem 0;
}
.client-form-container .case-selector-multi .dropdown-content .case-option {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s ease;
}
.client-form-container .case-selector-multi .dropdown-content .case-option:hover {
  background: #f9fafb;
}
.client-form-container .case-selector-multi .dropdown-content .case-option.selected {
  background: #eff6ff;
  color: #1e40af;
  border-left: 3px solid #3b82f6;
}
.client-form-container .case-selector-multi .dropdown-content .case-option.selected .case-parties {
  font-weight: 600;
}
.client-form-container .case-selector-multi .dropdown-content .case-option .case-details {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.client-form-container .case-selector-multi .dropdown-content .case-option .case-details .case-parties {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
  line-height: 1.4;
}
.client-form-container .case-selector-multi .dropdown-content .case-option .case-details .case-ref {
  font-size: 0.75rem;
  color: #6b7280;
  background: #f3f4f6;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  display: inline-block;
  width: fit-content;
}
.client-form-container .case-selector-multi .dropdown-content .case-option .case-details .case-number {
  font-size: 0.75rem;
  color: #9ca3af;
}
.client-form-container .case-selector-multi .dropdown-content .case-option .selected-icon {
  color: #10b981;
  margin-left: 0.75rem;
  flex-shrink: 0;
}
.client-form-container .case-selector-multi .dropdown-content .loading-state,
.client-form-container .case-selector-multi .dropdown-content .no-results,
.client-form-container .case-selector-multi .dropdown-content .empty-state {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.client-form-container .case-selector-multi .dropdown-content .loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.client-form-container .case-selector-multi .dropdown-content .loading-state::before {
  content: "";
  width: 16px;
  height: 16px;
  border: 2px solid #e5e7eb;
  border-top: 2px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.client-form-container .form-actions {
  display: flex;
  justify-content: end;
  gap: 1rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .client-form-container .form-actions {
    flex-direction: column;
  }
}
.client-form-container .form-actions .btn-primary {
  padding: 0.75rem 1.5rem;
  border-radius: 0.25rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  border: none;
  min-width: 120px;
  transition: all 0.2s ease;
}
@media (max-width: 768px) {
  .client-form-container .form-actions .btn-primary {
    width: 100%;
  }
}
.client-form-container .form-actions .btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.client-form-container .form-actions .btn-primary {
  background-color: var(--primary-color);
  color: white;
}
.client-form-container .form-actions .btn-primary:hover {
  background-color: #005a9a;
}
.client-form-container .form-actions .btn-primary:focus {
  outline: none;
}
.client-form-container .form-actions .btn-primary:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
}
.client-form-container .form-actions .btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.client-form-container .form-actions .btn-cancel:hover {
  background-color: #f8f9fa;
}

.client-form-modal-container {
  min-height: auto;
  background-color: #fff;
  padding: 0rem;
}
.client-form-modal-container .client-form-modal-wrapper {
  background: #ffffff;
  border: none;
  border-radius: 0px;
  padding: 0rem;
  box-shadow: none;
  width: 100%;
}

@keyframes client-form-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes dropdown-fade-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.client-form-container .case-selector-multi .dropdown-content::-webkit-scrollbar {
  width: 6px;
}

.client-form-container .case-selector-multi .dropdown-content::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.client-form-container .case-selector-multi .dropdown-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.client-form-container .case-selector-multi .dropdown-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@media (max-width: 1024px) {
  .client-form-container .client-form-wrapper {
    width: 85%;
  }
  .client-form-container .form-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
@media (max-width: 768px) {
  .client-form-container {
    padding: 1rem;
  }
  .client-form-container .client-form-wrapper {
    width: 95%;
  }
  .client-form-container .form-section {
    padding: 1rem;
  }
  .client-form-container .client-form-header .client-form-title {
    font-size: 1.25rem;
  }
  .client-form-container .form-section h3 {
    font-size: 1rem;
  }
  .client-form-container .case-selector-multi .dropdown-content {
    max-height: 200px;
  }
  .client-form-container .case-selector-multi .case-option {
    padding: 0.5rem 0.75rem;
  }
  .client-form-container .case-selector-multi .case-option .case-details .case-parties {
    font-size: 0.8125rem;
  }
  .client-form-container .case-selector-multi .case-tag {
    padding: 0.25rem 0.5rem;
    font-size: 0.6875rem;
  }
  .client-form-container .form-actions .btn-secondary,
  .client-form-container .form-actions .btn-primary {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
}
@media (max-width: 480px) {
  .client-form-container {
    padding: 0.5rem;
  }
  .client-form-container .client-form-wrapper {
    padding: 0.75rem;
    width: 100%;
  }
  .client-form-container .form-section {
    padding: 0.75rem;
  }
  .client-form-container .client-form-header .client-form-title {
    font-size: 1.125rem;
  }
  .client-form-container .form-group input,
  .client-form-container .form-group select,
  .client-form-container .form-group textarea {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
}
@media print {
  .client-form-container {
    background: white;
    padding: 0;
  }
  .client-form-container .client-form-wrapper {
    box-shadow: none;
    border: 1px solid #000;
  }
  .client-form-container .form-section {
    box-shadow: none;
    border: 1px solid #000;
    page-break-inside: avoid;
  }
  .client-form-container .form-actions,
  .client-form-container .dropdown-menu {
    display: none;
  }
  .client-form-container .case-tag .remove-btn {
    display: none;
  }
}
.client-form-container input:focus-visible,
.client-form-container select:focus-visible,
.client-form-container textarea:focus-visible,
.client-form-container button:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}
.client-form-container .toggle-switch input:focus-visible + .toggle-slider {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/forms/MyClientForm/MyClientForm.scss"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,mCAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EAXF;IAYI,aAAA;EACF;AACF;AAEE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,4CAAA;EACA,UAAA;AAAJ;AAEI;EATF;IAUI,aAAA;IACA,UAAA;EACJ;AACF;AAGE;EACE,kBAAA;EACA,kBAAA;EACA,qBAAA;AADJ;AAGI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AADN;AAGM;EANF;IAOI,kBAAA;EAAN;AACF;AAKE;EACE,YAAA;EACA,2CAAA;EACA,gBAAA;AAHJ;AAOE;EACE,UAAA;EACA,SAAA;EACA,YAAA;EACA,uBAAA;AALJ;AASE;EACE,uBAAA;EACA,uBAAA;EACA,qBAAA;AAPJ;AAUI;EACE,gBAAA;AARN;AAWI;EAVF;IAWI,aAAA;EARJ;AACF;AAUI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,8CAAA;AARN;AAaE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAXJ;AAaI;EACE,gBAAA;AAXN;AAcI;EATF;IAUI,sBAAA;IACA,WAAA;EAXJ;AACF;AAcE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AAZJ;AAcI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAZN;AAaM;EACE,cAAA;EACA,oBAAA;AAXR;AAgBI;;;EAGE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAdN;AAgBM;;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAZR;AAeM;;;EACE,qBAAA;AAXR;AAcM;;;EACE,cAAA;AAVR;AAaM;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AATR;AAaI;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AAXN;AAcI;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAZN;AAgBI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAdN;AAgBM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAdR;AAgBQ;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAdV;AAgBU;EACE,yBAAA;AAdZ;AAgBY;EACE,2BAAA;AAdd;AAkBU;EACE,6CAAA;AAhBZ;AAoBQ;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;EACA,mBAAA;EACA,yBAAA;AAlBV;AAoBU;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;AAlBZ;AAsBQ;EACE,yBAAA;AApBV;AAsBU;EACE,yBAAA;AApBZ;AAyBM;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AAvBR;AA2BI;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAzBN;AA8BE;EACE,WAAA;AA5BJ;AA+BE;EACE,kBAAA;EACA,WAAA;AA7BJ;AA+BI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA7BN;AAgCI;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;AA9BN;AAgCM;EACE,qBAAA;EACA,6CAAA;AA9BR;AAiCM;EACE,qBAAA;AA/BR;AAmCI;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAjCN;AAmCM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;AAjCR;AAmCQ;EACE,cAAA;AAjCV;AAqCM;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,oBAAA;EACA,+BAAA;AAnCR;AAqCQ;EACE,yBAAA;AAnCV;AAwCI;EACE,gBAAA;EACA,yCAAA;EACA,gBAAA;EACA,mBAAA;AAtCN;AAyCI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAvCN;AA2CM;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,uBAAA;AAzCR;AA4CM;EACE,aAAA;EACA,eAAA;EACA,aAAA;AA1CR;AA8CI;EACE,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AA5CN;AA8CM;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AA5CR;AA8CQ;EACE,yBAAA;AA5CV;AAgDM;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AA9CR;AAgDQ;EACE,yBAAA;AA9CV;AAkDM;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAhDR;AAkDQ;EACE,yBAAA;AAhDV;AAoDM;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AAlDR;AAoDQ;EACE,UAAA;EACA,0CAAA;EACA,qBAAA;AAlDV;AAuDI;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AArDN;AAwDI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,qFAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;AAtDN;AAyDI;EACE,mBAAA;EACA,gCAAA;AAvDN;AAyDM;EACE,aAAA;AAvDR;AAyDQ;EACE,SAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,oCAAA;AAvDV;AAyDU;EACE,mBAAA;EACA,cAAA;AAvDZ;AA0DU;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;AAxDZ;AA8DI;EACE,iBAAA;EACA,gBAAA;AA5DN;AA8DM;EACE,kBAAA;AA5DR;AA+DM;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;AA7DR;AA+DQ;EACE,mBAAA;AA7DV;AAgEQ;EACE,mBAAA;EACA,cAAA;EACA,8BAAA;AA9DV;AAgEU;EACE,gBAAA;AA9DZ;AAkEQ;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAhEV;AAkEU;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAhEZ;AAmEU;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;AAjEZ;AAoEU;EACE,kBAAA;EACA,cAAA;AAlEZ;AAsEQ;EACE,cAAA;EACA,oBAAA;EACA,cAAA;AApEV;AAwEM;;;EAGE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAtER;AAyEM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAvER;AAyEQ;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;AAvEV;AA8EE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;AA5EJ;AA8EI;EARF;IASI,sBAAA;EA3EJ;AACF;AA6EI;EACE,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;AA3EN;AA6EM;EAVF;IAWI,WAAA;EA1EN;AACF;AA4EM;EACE,YAAA;EACA,mBAAA;AA1ER;AA4FI;EACE,sCAAA;EACA,YAAA;AA1FN;AA4FM;EACE,yBAAA;AA1FR;AA4FM;EACE,aAAA;AA1FR;AA6FM;EACE,yBAAA;EACA,cAAA;AA3FR;AA8FI;EACE,iBAAA;EACF,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AA5FJ;AA8FI;EACE,yBAAA;AA5FN;;AAkGA;EACE,gBAAA;EACA,sBAAA;EACA,aAAA;AA/FF;AAiGE;EACG,mBAAA;EACD,YAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;AA/FJ;;AAoGA;EACE;IACE,UAAA;IACA,2BAAA;EAjGF;EAmGA;IACE,UAAA;IACA,wBAAA;EAjGF;AACF;AAoGA;EACE;IACE,UAAA;IACA,2BAAA;EAlGF;EAoGA;IACE,UAAA;IACA,wBAAA;EAlGF;AACF;AAqGA;EACE;IACE,uBAAA;EAnGF;EAqGA;IACE,yBAAA;EAnGF;AACF;AAuGA;EACE,UAAA;AArGF;;AAwGA;EACE,mBAAA;EACA,kBAAA;AArGF;;AAwGA;EACE,mBAAA;EACA,kBAAA;EACA,8CAAA;EAAA,sCAAA;AArGF;;AAwGA;EACE,mBAAA;AArGF;;AAyGA;EAEI;IACE,UAAA;EAvGJ;EA0GE;IACE,sBAAA;IACA,WAAA;EAxGJ;AACF;AA4GA;EACE;IACE,aAAA;EA1GF;EA4GE;IACE,UAAA;EA1GJ;EA6GE;IACE,aAAA;EA3GJ;EA8GE;IACE,kBAAA;EA5GJ;EA+GE;IACE,eAAA;EA7GJ;EAiHI;IACE,iBAAA;EA/GN;EAkHI;IACE,uBAAA;EAhHN;EAmHQ;IACE,oBAAA;EAjHV;EAsHI;IACE,uBAAA;IACA,oBAAA;EApHN;EAyHI;;IAEE,oBAAA;IACA,oBAAA;EAvHN;AACF;AA4HA;EACE;IACE,eAAA;EA1HF;EA4HE;IACE,gBAAA;IACA,WAAA;EA1HJ;EA6HE;IACE,gBAAA;EA3HJ;EA8HE;IACE,mBAAA;EA5HJ;EAgII;;;IAGE,iBAAA;IACA,oBAAA;EA9HN;AACF;AAoIA;EACE;IACE,iBAAA;IACA,UAAA;EAlIF;EAoIE;IACE,gBAAA;IACA,sBAAA;EAlIJ;EAqIE;IACE,gBAAA;IACA,sBAAA;IACA,wBAAA;EAnIJ;EAsIE;;IAEE,aAAA;EApIJ;EAuIE;IACE,aAAA;EArIJ;AACF;AA2IE;;;;EAIE,0BAAA;EACA,mBAAA;AAzIJ;AA4IE;EACE,0BAAA;EACA,mBAAA;AA1IJ","sourcesContent":["// Main Container - Match HighCourtCaseForm styling\n.client-form-container {\n  min-height: 100vh;\n  background: var(--grey-shade-three);\n  padding: 2rem;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 0;\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n\n  // Form Content Wrapper (to match LabelForm card style)\n  .client-form-wrapper {\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    padding: 1.5rem;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    animation: client-form-fade-in 0.3s ease-out;\n    width: 70%;\n\n    @media (max-width: 768px) {\n      padding: 1rem;\n      width: 95%;\n    }\n  }\n\n  // Header styling (similar to LabelForm)\n  .client-form-header {\n    position: relative;\n    text-align: center;\n    margin-bottom: 0.5rem;\n\n    .client-form-title {\n      font-size: 1.3rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0;\n\n      @media (max-width: 768px) {\n        font-size: 1.25rem;\n      }\n    }\n  }\n\n  // Divider styling (match LabelForm)\n  .client-form-divider {\n    border: none;\n    border-top: 1px solid var(--grey-shade-two);\n    margin: 1.5rem 0;\n  }\n\n  // Form content styling\n  .client-form-content {\n    padding: 0;\n    margin: 0;\n    border: none;\n    background: transparent;\n  }\n\n  // Form structure styling\n  .form-section {\n    background: transparent;\n    border-radius: 0.375rem;\n    margin-bottom: 1.5rem;\n    // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n\n    &.end-client {\n      margin-bottom: 0;\n    }\n\n    @media (max-width: 768px) {\n      padding: 1rem;\n    }\n\n    h3 {\n      font-size: 1rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0 0 1rem 0;\n      padding-bottom: 0.5rem;\n      border-bottom: 1px solid var(--grey-shade-two);\n    }\n  }\n\n  // Form rows and groups\n  .form-row {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 1rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      gap: 0.5rem;\n    }\n  }\n\n  .form-group {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n\n    label {\n      display: block;\n      margin-bottom: 0.5rem;\n      font-weight: 500;\n      font-size: 0.875rem;\n      color: #374151;\n      .clientform-required {\n        color: #ef4444;\n        margin-left: 0.25rem;\n      }\n    }\n\n    // Input styling to match HighCourtCaseForm\n    input,\n    select,\n    textarea {\n      width: 100%;\n      padding: 0.5rem;\n      border: 1px solid #d1d5db;\n      border-radius: 0.25rem;\n      font-size: 0.875rem;\n      font-family: inherit;\n      color: #374151;\n      background: #ffffff;\n      box-sizing: border-box;\n      height: 2.5rem;\n\n      &:focus {\n        outline: none;\n        border-color: #3b82f6;\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n      }\n\n      &:hover:not(:focus) {\n        border-color: #9ca3af;\n      }\n\n      &::placeholder {\n        color: #9ca3af;\n      }\n\n      &:disabled {\n        background-color: #f9fafb;\n        color: #6b7280;\n        cursor: not-allowed;\n      }\n    }\n\n    select {\n      appearance: none;\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n      background-position: right 0.5rem center;\n      background-repeat: no-repeat;\n      background-size: 1.5rem 1.5rem;\n      padding-right: 2.5rem;\n    }\n\n    textarea {\n      height: auto;\n      min-height: 4rem;\n      resize: vertical;\n      line-height: 1.5;\n    }\n\n    // Toggle switch styles\n    .toggle-container {\n      display: flex;\n      align-items: center;\n      gap: 0.75rem;\n      margin-top: 0.5rem;\n\n      .toggle-switch {\n        position: relative;\n        width: 50px;\n        height: 24px;\n        cursor: pointer;\n\n        input[type=\"checkbox\"] {\n          opacity: 0;\n          position: absolute;\n          width: 0;\n          height: 0;\n\n          &:checked + .toggle-slider {\n            background-color: #3b82f6;\n            \n            &:before {\n              transform: translateX(26px);\n            }\n          }\n\n          &:focus + .toggle-slider {\n            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n          }\n        }\n\n        .toggle-slider {\n          position: absolute;\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          background-color: var(--grey-main-bg);\n          border-radius: 24px;\n          transition: all 0.3s ease;\n\n          &:before {\n            content: '';\n            position: absolute;\n            height: 18px;\n            width: 18px;\n            left: 3px;\n            top: 3px;\n            background-color: white;\n            border-radius: 50%;\n            transition: all 0.3s ease;\n            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n          }\n        }\n\n        &:hover .toggle-slider {\n          background-color: #9ca3af;\n\n          input:checked + & {\n            background-color: #2563eb;\n          }\n        }\n      }\n\n      .toggle-label {\n        font-size: 0.875rem;\n        font-weight: 500;\n        color: #374151;\n      }\n    }\n\n    .toggle-description {\n      font-size: 0.75rem;\n      color: #6b7280;\n      margin-top: 0.375rem;\n      font-style: italic;\n      line-height: 1.4;\n    }\n  }\n\n  // Case selector styles - Enhanced to match HighCourtCaseForm\n  .case-selector-container {\n    width: 100%;\n  }\n\n  .case-selector-multi {\n    position: relative;\n    width: 100%;\n\n    label {\n      display: block;\n      margin-bottom: 0.5rem;\n      font-weight: 500;\n      font-size: 0.875rem;\n      color: #374151;\n    }\n\n    .dropdown-wrapper {\n      position: relative;\n      border: 1px solid #d1d5db;\n      border-radius: 0.25rem;\n      background: #ffffff;\n      transition: all 0.2s ease;\n\n      &:focus-within {\n        border-color: #3b82f6;\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n      }\n\n      &:hover:not(:focus-within) {\n        border-color: #9ca3af;\n      }\n    }\n\n    .search-input-container {\n      position: relative;\n      display: flex;\n      align-items: center;\n\n      .search-input {\n        width: 100%;\n        border: none;\n        outline: none;\n        padding: 0.5rem;\n        font-size: 0.875rem;\n        background: transparent;\n        height: 2.5rem;\n        box-sizing: border-box;\n        color: #374151;\n\n        &::placeholder {\n          color: #9ca3af;\n        }\n      }\n\n      .dropdown-arrow {\n        position: absolute;\n        right: 0.5rem;\n        color: #6b7280;\n        pointer-events: none;\n        transition: transform 0.2s ease;\n\n        .dropdown-wrapper:focus-within & {\n          transform: rotate(180deg);\n        }\n      }\n    }\n\n    .selected-cases-container {\n      padding: 0.75rem;\n      border-top: 1px solid var(--grey-main-bg);\n      min-height: 2rem;\n      background: #f9fafb;\n    }\n\n    .selected-cases-grid {\n      display: flex;\n      flex-direction: column;\n      gap: 0.75rem;\n    }\n\n    .court-section {\n      .court-label {\n        font-size: 0.75rem;\n        font-weight: 600;\n        color: #6b7280;\n        margin-bottom: 0.5rem;\n        text-transform: uppercase;\n        letter-spacing: 0.025em;\n      }\n\n      .cases-tags {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 0.375rem;\n      }\n    }\n\n    .case-tag {\n      display: inline-flex;\n      align-items: center;\n      gap: 0.375rem;\n      padding: 0.375rem 0.75rem;\n      border-radius: 1rem;\n      font-size: 0.75rem;\n      font-weight: 500;\n      transition: all 0.2s ease;\n\n      &.high-court {\n        background-color: #fef3c7;\n        color: #92400e;\n        border: 1px solid #f59e0b;\n\n        &:hover {\n          background-color: #fde68a;\n        }\n      }\n\n      &.district-court {\n        background-color: #dbeafe;\n        color: #1e40af;\n        border: 1px solid #3b82f6;\n\n        &:hover {\n          background-color: #bfdbfe;\n        }\n      }\n\n      &.other-court {\n        background-color: #f3e8ff;\n        color: #7c3aed;\n        border: 1px solid #8b5cf6;\n\n        &:hover {\n          background-color: #e9d5ff;\n        }\n      }\n\n      .remove-btn {\n        background: none;\n        border: none;\n        color: currentColor;\n        cursor: pointer;\n        font-size: 1rem;\n        padding: 0;\n        width: 18px;\n        height: 18px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 50%;\n        opacity: 0.7;\n        transition: all 0.2s ease;\n\n        &:hover {\n          opacity: 1;\n          background-color: rgba(255, 255, 255, 0.6);\n          transform: scale(1.1);\n        }\n      }\n    }\n\n    .no-selection {\n      color: #9ca3af;\n      font-style: italic;\n      font-size: 0.875rem;\n      text-align: center;\n      padding: 1rem;\n    }\n\n    .dropdown-menu {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      right: 0;\n      z-index: 1000;\n      background: #ffffff;\n      border: 1px solid #d1d5db;\n      border-radius: 0.375rem;\n      box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n      margin-top: 0.25rem;\n      overflow: hidden;\n      animation: dropdown-fade-in 0.2s ease-out;\n    }\n\n    .dropdown-header {\n      background: #f9fafb;\n      border-bottom: 1px solid #e5e7eb;\n\n      .court-tabs {\n        display: flex;\n\n        .tab-btn {\n          flex: 1;\n          padding: 0.75rem 1rem;\n          border: none;\n          background: transparent;\n          color: #6b7280;\n          font-weight: 500;\n          font-size: 0.875rem;\n          cursor: pointer;\n          transition: all 0.2s ease;\n          border-bottom: 2px solid transparent;\n\n          &:hover {\n            background: #f3f4f6;\n            color: #374151;\n          }\n\n          &.active {\n            background: #ffffff;\n            color: #3b82f6;\n            font-weight: 600;\n            border-bottom-color: #3b82f6;\n          }\n        }\n      }\n    }\n\n    .dropdown-content {\n      max-height: 250px;\n      overflow-y: auto;\n\n      .cases-list {\n        padding: 0.25rem 0;\n      }\n\n      .case-option {\n        display: flex;\n        align-items: center;\n        padding: 0.75rem 1rem;\n        cursor: pointer;\n        border-bottom: 1px solid #f3f4f6;\n        transition: all 0.2s ease;\n\n        &:hover {\n          background: #f9fafb;\n        }\n\n        &.selected {\n          background: #eff6ff;\n          color: #1e40af;\n          border-left: 3px solid #3b82f6;\n\n          .case-parties {\n            font-weight: 600;\n          }\n        }\n\n        .case-details {\n          flex: 1;\n          display: flex;\n          flex-direction: column;\n          gap: 0.25rem;\n\n          .case-parties {\n            font-weight: 500;\n            color: #374151;\n            font-size: 0.875rem;\n            line-height: 1.4;\n          }\n\n          .case-ref {\n            font-size: 0.75rem;\n            color: #6b7280;\n            background: #f3f4f6;\n            padding: 0.125rem 0.375rem;\n            border-radius: 0.25rem;\n            display: inline-block;\n            width: fit-content;\n          }\n\n          .case-number {\n            font-size: 0.75rem;\n            color: #9ca3af;\n          }\n        }\n\n        .selected-icon {\n          color: #10b981;\n          margin-left: 0.75rem;\n          flex-shrink: 0;\n        }\n      }\n\n      .loading-state,\n      .no-results,\n      .empty-state {\n        padding: 2rem 1rem;\n        text-align: center;\n        color: #6b7280;\n        font-style: italic;\n        font-size: 0.875rem;\n      }\n\n      .loading-state {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 0.5rem;\n\n        &::before {\n          content: '';\n          width: 16px;\n          height: 16px;\n          border: 2px solid #e5e7eb;\n          border-top: 2px solid #3b82f6;\n          border-radius: 50%;\n          animation: spin 1s linear infinite;\n        }\n      }\n    }\n  }\n\n  // Form actions to match HighCourtCaseForm\n  .form-actions {\n    display: flex;\n    justify-content: end;\n    gap: 1rem;\n    margin-top: 1.5rem;\n    padding-top: 1rem;\n    border-top: 1px solid #e5e7eb;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n    }\n\n    .btn-primary {\n      padding: 0.75rem 1.5rem;\n      border-radius: 0.25rem;\n      font-weight: 500;\n      font-size: 0.875rem;\n      cursor: pointer;\n      border: none;\n      min-width: 120px;\n      transition: all 0.2s ease;\n\n      @media (max-width: 768px) {\n        width: 100%;\n      }\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n      }\n    }\n\n    // .btn-secondary {\n    //   background-color: #dc2626;\n    //   color: white;\n\n    //   &:hover:not(:disabled) {\n    //     background-color: #b91c1c;\n    //   }\n\n    //   &:focus {\n    //     outline: none;\n    //     box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);\n    //   }\n    // }\n\n    .btn-primary {\n      background-color: var(--primary-color);\n      color: white;\n\n      &:hover{\n        background-color: #005a9a;\n      }\n      &:focus {\n        outline: none;\n      }\n\n      &:disabled {\n        background-color: #d1d5db;\n        color: #9ca3af;\n      }\n    }\n    .btn-cancel{\n      padding: 8px 16px;\n    border: 1px solid #ddd;\n    background: white;\n    color: #666;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n\n    &:hover {\n      background-color: #f8f9fa;\n    }\n    }\n  }\n}\n\n.client-form-modal-container{\n  min-height: auto;\n  background-color: #fff;\n  padding: 0rem;\n\n  .client-form-modal-wrapper{\n     background: #ffffff;\n    border: none;\n    border-radius: 0px;\n    padding: 0rem;\n    box-shadow: none;\n    width: 100%;\n  }\n}\n\n// Animations\n@keyframes client-form-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes dropdown-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n// Scrollbar styling for dropdown\n.client-form-container .case-selector-multi .dropdown-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.client-form-container .case-selector-multi .dropdown-content::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.client-form-container .case-selector-multi .dropdown-content::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n  transition: background-color 0.2s ease;\n}\n\n.client-form-container .case-selector-multi .dropdown-content::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n// Responsive design improvements\n@media (max-width: 1024px) {\n  .client-form-container {\n    .client-form-wrapper {\n      width: 85%;\n    }\n\n    .form-row {\n      flex-direction: column;\n      gap: 0.5rem;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .client-form-container {\n    padding: 1rem;\n\n    .client-form-wrapper {\n      width: 95%;\n    }\n\n    .form-section {\n      padding: 1rem;\n    }\n\n    .client-form-header .client-form-title {\n      font-size: 1.25rem;\n    }\n\n    .form-section h3 {\n      font-size: 1rem;\n    }\n\n    .case-selector-multi {\n      .dropdown-content {\n        max-height: 200px;\n      }\n\n      .case-option {\n        padding: 0.5rem 0.75rem;\n\n        .case-details {\n          .case-parties {\n            font-size: 0.8125rem;\n          }\n        }\n      }\n\n      .case-tag {\n        padding: 0.25rem 0.5rem;\n        font-size: 0.6875rem;\n      }\n    }\n\n    .form-actions {\n      .btn-secondary,\n      .btn-primary {\n        padding: 0.5rem 1rem;\n        font-size: 0.8125rem;\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .client-form-container {\n    padding: 0.5rem;\n\n    .client-form-wrapper {\n      padding: 0.75rem;\n      width: 100%;\n    }\n\n    .form-section {\n      padding: 0.75rem;\n    }\n\n    .client-form-header .client-form-title {\n      font-size: 1.125rem;\n    }\n\n    .form-group {\n      input,\n      select,\n      textarea {\n        padding: 0.375rem;\n        font-size: 0.8125rem;\n      }\n    }\n  }\n}\n\n// Print styles\n@media print {\n  .client-form-container {\n    background: white;\n    padding: 0;\n\n    .client-form-wrapper {\n      box-shadow: none;\n      border: 1px solid #000;\n    }\n\n    .form-section {\n      box-shadow: none;\n      border: 1px solid #000;\n      page-break-inside: avoid;\n    }\n\n    .form-actions,\n    .dropdown-menu {\n      display: none;\n    }\n\n    .case-tag .remove-btn {\n      display: none;\n    }\n  }\n}\n\n// Focus visible improvements for accessibility\n.client-form-container {\n  input:focus-visible,\n  select:focus-visible,\n  textarea:focus-visible,\n  button:focus-visible {\n    outline: 2px solid #3b82f6;\n    outline-offset: 2px;\n  }\n\n  .toggle-switch input:focus-visible + .toggle-slider {\n    outline: 2px solid #3b82f6;\n    outline-offset: 2px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
